import React from 'react'
import { useQueryParams, StringParam } from 'use-query-params'
import { AdditionalAccessControlsProvider } from '@retailer-platform/dashboard/access-control'
import type { ScopePickerComponentProps } from '@retailer-platform/dashboard/routing'
import { FeatureEntitlements } from '../../access-control/featureEntitlements'

const VEHICLES_TAB_ADDITIONAL_ACCESS_CONTROLS = [
  {
    featureEntitlementIds: [FeatureEntitlements.PartnerBulkDeliveryEnabled],
    restrictedBannersAllowed: true,
  },
]

/**
 * Custom scope picker wrapper for the Partner Pick Devices list route.
 *
 * The visible scope selector for this route is rendered inline inside the TDS
 * PageHeader's `filters` slot (see PartnerPickDevicesHeader). The standard
 * RetailerScopeWrapper is intentionally NOT used here because it always
 * renders a bordered Header container (with `border-bottom`) above the page
 * content — even when `hiddenScopePicker` is set — which produces the
 * unwanted horizontal divider directly beneath the TDS PageHeader. The page
 * content is rendered directly so the page can own its own layout (including
 * the 80px horizontal margin used on other partner-level pages).
 *
 * The wrapper still applies the AdditionalAccessControlsProvider that greys
 * out warehouses without the partner bulk delivery entitlement when the user
 * is on the Vehicles tab.
 */
export const PartnerPickDevicesScopePicker: React.FC<ScopePickerComponentProps> = ({
  children,
}) => {
  const [{ tab }] = useQueryParams({ tab: StringParam })

  if (tab !== 'vehicles') {
    return <>{children}</>
  }

  return (
    <AdditionalAccessControlsProvider
      additionalAccessControls={VEHICLES_TAB_ADDITIONAL_ACCESS_CONTROLS}
    >
      {children}
    </AdditionalAccessControlsProvider>
  )
}
